(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-videos-section').forEach(function (section) {

      // --- Tabs ---
      const tabs = section.querySelectorAll('[data-tab-target]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const target = tab.getAttribute('data-tab-target');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          section.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
          });
        });
      });

      // --- Abrir modal con el video completo al hacer click ---
      section.querySelectorAll('[data-video-card]').forEach(function (card) {
        const media = card.querySelector('.product-video-card__media');

        media.addEventListener('click', function () {
          const source = card.querySelector('[data-video-source]');
          const modal = document.querySelector('[data-video-modal]');
          const player = modal.querySelector('[data-video-modal-player]');

          player.innerHTML = source.innerHTML;
          modal.hidden = false;
        });
      });
    });

    // --- Cerrar modal ---
    document.querySelectorAll('[data-video-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        const modal = document.querySelector('[data-video-modal]');
        modal.querySelector('[data-video-modal-player]').innerHTML = '';
        modal.hidden = true;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
